<template>
  <div>
    <auth-layout
      :isLoading="isLoading"
      contentClass="pt-0"
      pageClass="login-page"
      styleContent="min-height: auto"
    >
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-lg-4 col-md-5 col-sm-7">
          <form method="POST">
            <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
            <fade-render-transition>
              <card class="card-login">
                <div slot="header" class="text-center">
                  <img
                    src="/static/img/Logo SmartCultivo.png"
                    alt="Logo SmartCultivo"
                    class="img-fluid"
                  />
                </div>
                <div>
                  <fg-input
                    :label="$t('common_words.user')"
                    v-validate="modelValidations.user"
                    v-on:keyup="validate"
                    :error="getError('common_words.user', true)"
                    name="common_words.user"
                    placeholder=""
                    type="text"
                    v-model="model.login"
                  >
                  </fg-input>
                  <label>{{ $t('common_words.password') }}</label>
                  <fg-input
                    v-validate="modelValidations.password"
                    v-on:keyup="validate"
                    :error="getError('common_words.password', true)"
                    name="common_words.password"
                    :type="inputTypePass"
                    :myCustom="{ addon: 'not-input-group-addon' }"
                    placeholder=""
                    v-model="model.password"
                    class="mb-4"
                  >
                    <template slot="addonRight">
                      <l-button @click="showPassword" class="btn-round">
                        <em :class="iconBtnPass"></em>
                      </l-button>
                    </template>
                  </fg-input>
                  <fg-input class="mb-0">
                    <l-checkbox
                      v-model="model.remember_me"
                      class="remember-text custom-remember_me mb-0"
                    >
                      {{ $t('vie.Pag.Aut.Login.remindMe') }}
                    </l-checkbox>
                  </fg-input>
                  <div class="text-right btn-login">
                    <button
                      id="btnLogin"
                      type="submit"
                      class="btn btn-fill btn-info btn-round"
                      @click.prevent="validateSubmit"
                      :disabled="enabledBtn"
                    >
                      {{ $t('vie.Pag.Aut.Login.access') }}
                    </button>
                  </div>
                  <div class="row mt-4 text-center">
                    <div class="col">
                      <!--btn-fill btn-round btn-wd-->
                      <l-button
                        style="width: 100%"
                        type="social"
                        v-on:click="isLoading = true"
                        class="btn-google"
                        size="md"
                        @click.prevent="AuthProvider('google')"
                      >
                        <em class="fa fa-google"></em>
                        &nbsp;{{ $t('vie.Pag.Aut.Login.enterWithGoogle') }}
                      </l-button>
                    </div>
                  </div>
                  <div class="row mt-1 text-center">
                    <div class="col">
                      <l-button
                        style="width: 100%"
                        type="social"
                        v-on:click="isLoading = true"
                        class="btn-microsoft"
                        size="md"
                        @click.prevent="loginMicrosoft"
                      >
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                          alt="Microsoft"
                          style="width: 22px; height: 22px"
                        />

                        &nbsp;&nbsp;{{
                          $t('vie.Pag.Aut.Login.enterWithMicrosoft')
                        }}
                      </l-button>
                    </div>
                  </div>
                  <br />
                  <div class="forgot text-center">
                    <a
                      @click="showSwalPasswordRequest"
                      class="card-category pointer"
                    >
                      {{ $t('vie.Pag.Aut.Login.forgotYourPassword') }}
                    </a>
                  </div>
                  <div class="text-center d-flex justify-content-end mt-3">
                    <menu-translate
                      m="mr-0"
                      :isSelect="true"
                      :showAbbreviation="false"
                    />
                  </div>
                </div>
              </card>
            </fade-render-transition>
          </form>
        </div>
      </div>
      <app-politics
        v-model="showPolitics"
        :policy="policy"
        @confirm="confirm"
      />
    </auth-layout>
  </div>
</template>
<script>
import { AXIOS_URL, DISK_URL, setLocalizeLanguage } from 'src/util/Util';
import {
  Checkbox as LCheckbox,
  FadeRenderTransition,
} from 'src/components/index';
import { mapActions } from 'vuex';
import AppPolitics from './AppPolitics.vue';
import AuthLayout from 'src/views/Layouts/AuthLayout.vue';
import axios from 'axios';
import i18n from 'src/i18n';
import MenuTranslate from 'src/views/Layouts/MenuTranslate.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinPolitics from 'src/mixins/mixin-politics';
import SweetAlert from 'src/class/Alerts';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueSocialauth from 'vue-social-auth';

//Languajes
Vue.use(VeeValidate);
setLocalizeLanguage();

// Definimos la configuracion basica de vue-social-auth
Vue.use(VueAxios, axios);
Vue.use(VueSocialauth, {
  baseUrl: AXIOS_URL, // Your API domain
  providers: {
    google: {
      clientId:
        '48643883768-u6tdu311t5m61r77effqu4o7hub86qr1.apps.googleusercontent.com',
      //redirectUri: AXIOS_URL + '/auth/google/callback' // Your client app URL
      redirectUri: AXIOS_URL + '/auth/google/callback', // Your client app URL
    },
  },
});

export default {
  name: 'signin',
  components: {
    LCheckbox,
    FadeRenderTransition,
    AuthLayout,
    AppPolitics,
    MenuTranslate,
  },
  data() {
    return {
      enabledBtn: false,
      model: {
        login: '',
        password: '',
        remember_me: false,
      },
      modelValidations: {
        user: {
          required: true,
        },
        password: {
          required: true,
          min: 8,
        },
      },
      inputTypePass: 'password',
      iconBtnPass: 'fa fa-eye',
    };
  },
  watch: {
    showPolitics(newVal) {
      if (!newVal) {
        this.logout();
      } else {
        setTimeout(() => {
          document.getElementsByClassName('v-modal')[0].remove();
        }, 300);
      }
    },
  },

  mixins: [MixinForm, mixinPolitics],
  methods: {
    /**
     *  mapeamos las acciones de nuestro store para poder llamarlas desde este script
     */
    ...mapActions({
      login: 'auth/login',
      logout: 'auth/logout',
      closeAllUserSessions: 'auth/closeAllUserSessions',
      loginGoogle: 'auth/loginGoogle',
      passwordRequest: 'auth/passwordRequest',
    }),
    getDISK_URL() {
      return DISK_URL;
    },

    // Redirige al backend para iniciar OAuth
    loginMicrosoft() {
      window.location.href = this.getDISK_URL() + 'auth/microsoft';
    },

    /* este metodo se encagar de llamar nuestra accion login del store*/
    signin() {
      this.isLoading = true;
      // llamamos a la accion enviando los datos del formulario por parametro
      this.login(this.model)
        .then((response) => {
          // en caso de respuesta, redireccionamos al usuario
          if (response.data && response.data.code) {
            this.auth(response);
          } else {
            this.validatePolitics();
          }
        })
        .catch((error) => {
          if (error.response.data.code && error.response.data.code == 4) {
            SweetAlert.default(
              i18n.t('vie.Pag.Aut.Login.activeSession'),
              `<p> ${error.response.data.message} </p>`,
              i18n.t('vie.Pag.Aut.Login.closeActiveSessions')
            ).then((result) => {
              // si el usuario acepta llamamos a la ruta de cambio con el token
              if (result.value) {
                this.isLoading = true;
                this.closeAllUserSessions(this.model).then((response) => {
                  this.isLoading = false;
                  SweetAlert.success(response.data.message).then((result) => {
                    this.isLoading = true;
                    this.login(this.model).then((response) => {
                      this.validatePolitics();
                    });
                  });
                });
              }
            });
          } else {
            // en caso de error mostramos una alerta
            const msg = error.response.message
              ? error.response.message
              : error.response.data.message;

            if (error.response.data.code && error.response.data.code === 474) {
              SweetAlert.warning(msg);
            } else {
              SweetAlert.danger(msg);
            }
          }

          this.isLoading = false;
        });
    },

    // este metodo se encarga de llamar a nuestro proveedor de login
    AuthProvider(provider) {
      var self = this;
      // llamamos al metodo authenticate de la libreria con el proveedor
      this.$auth
        .authenticate(provider)
        .then((response) => {
          self.SocialLogin(provider, response);
        })
        .catch((err) => {
          SweetAlert.danger(i18n.t('vie.Pag.Aut.Login.errorText1') + err);
          this.isLoading = false;
        });
    },

    // realizamos una peticion a la api con los datos del proveedor
    SocialLogin(provider, response) {
      this.$http
        .post('/auth/sociallogin/' + provider, response)
        .then((response) => {
          // si el usuario existe, obtenemos el token y hacemos el login
          this.loginGoogle(response.data.data.access_token)
            .then(() => {
              if (response.data && response.data.code) {
                this.auth(response);
              } else {
                this.validatePolitics();
              }
            })
            .catch(() => {
              this.isLoading = false;
            });
        })
        .catch((error) => {
          if (error.response.data.code && error.response.data.code == 4) {
            SweetAlert.default(
              i18n.t('vie.Pag.Aut.Login.activeSession'),
              `<p> ${error.response.data.message} </p>`,
              i18n.t('vie.Pag.Aut.Login.closeActiveSessions')
            ).then((result) => {
              // si el usuario acepta llamamos a la ruta de cambio con el token
              if (result.value) {
                this.isLoading = true;
                this.closeAllUserSessions({
                  login: error.response.data.data,
                }).then((response1) => {
                  this.isLoading = false;
                  SweetAlert.success(response1.data.message).then(() => {
                    this.AuthProvider('google');
                  });
                });
              }
            });
          } else {
            let message = error.response
              ? error.response.data.message
              : i18n.t('vie.Pag.Aut.Login.communicationWithServerError');
            if (
              error.response ||
              (error.response.data.code && error.response.data.code === 474)
            ) {
              SweetAlert.warning(message);
            } else {
              SweetAlert.danger(message);
            }
          }

          this.isLoading = false;
        });
    },

    // este metodo se encarga de mostrar un alert para solicitar cambio de contraseña
    showSwalPasswordRequest() {
      SweetAlert.input(
        i18n.t('vie.Pag.Aut.Login.resetPassword'),
        i18n.t('vie.Pag.Aut.Login.resetPasswordText1'),
        i18n.t('vie.Pag.Aut.Login.sendLink'),
        {
          type: 'text',
          placeholder: i18n.t('vie.Pag.Aut.Login.emailOrUser'),
        }
      )
        .then(
          function (result) {
            // si el usario ingresa su email, llamamos a otra funcion con ese valor
            if (result.value) {
              this.passRequestEmail({ login: result.value });
            }
          }.bind(this)
        )
        .catch((error) => {
          SweetAlert.danger(error.response.data.message);
          this.isLoading = false;
        });
    },

    // llamamos a nuestra accion pasandole por parametro el email del usuario
    passRequestEmail(user) {
      this.passwordRequest(user)
        .then((response) => {
          // si el usuario tiene contraseña temporal lo llevamos al cambio de contraseña
          if (user.password_temporary) {
            SweetAlert.default(
              i18n.t('vie.Pag.Aut.Login.changePassword'),
              `<p> ${i18n.t('vie.Pag.Aut.Login.changePasswordText1')} </p>`,
              i18n.t('common_words.continue')
            ).then((result) => {
              // si el usuario acepta llamamos a la ruta de cambio con el token
              if (result.value) {
                this.$router.push(
                  '/password_reset/' + response.data.data.token
                );
              }
            });
          } else {
            // en caso de que no sea contraseña temporal
            switch (response.data.code) {
              case 1:
                SweetAlert.success(response.data.message);
                break;
              case 2:
                SweetAlert.warning(response.data.message);
                break;
              default:
                SweetAlert.success(response.data.message);
                break;
            }
          }

          this.isLoading = false;
        })
        .catch((e) => {
          const msg = e.response.data.message;
          if (error.response.data.code && error.response.data.code === 474) {
            SweetAlert.warning(msg);
          } else {
            SweetAlert.danger(msg);
          }
          this.isLoading = false;
        });
    },

    // este metodo permite mostrar/ocultar la contraseña en el formulario
    showPassword() {
      if (this.inputTypePass === 'password') {
        this.iconBtnPass = 'fa fa-eye-slash';
        this.inputTypePass = 'text';
      } else {
        this.iconBtnPass = 'fa fa-eye';
        this.inputTypePass = 'password';
      }
    },

    toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },

    closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },

    validate() {
      this.$validator
        .validateAll()
        .then((isValid) => {
          this.enabledBtn = !isValid;
        })
        .catch((e) => {
          this.enabledBtn = false;
          this.isLoading = false;
        });
    },

    validateSubmit() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) this.signin();
      });
    },

    setRememberMe(params) {
      if (!params) {
        var date = new Date();
        date.setDate(date.getDate() + 365);
        this.$cookie.set('remember_me', true, { expires: date });
      } else this.$cookie.delete('remember_me');
    },
  },

  /**
   * llamamos al mounted y realizamos una peticion axios al back
   * para cargar las politicas y tomar sola la ultima politica (la mas actual)
   */
  beforeCreate() {
    axios
      .get('policyversions/index')
      .then((response) => {
        if (response.data.data) {
          this.policy = response.data.data[0];
        }
      })
      .catch((error) => {
        SweetAlert.warning(error.response.data.message);
      });
  },

  mounted() {
    const rememberMe = this.$cookie.get('remember_me');
    if (Boolean(rememberMe)) {
      this.model.remember_me = true;
    } else {
      this.model.remember_me = false;
    }
  },

  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.translate-login {
  position: absolute;
  top: 40px;
  right: 15px;
}
</style>
